import { z } from "zod";

export const analyticsBindEventDataSchema = z.object({
  event: z.string(),
  value: z.string()
});